// extracted by mini-css-extract-plugin
export default {"consultationContainer":"ipdTimelineMainLayout_consultationContainer__EJIaZ","title":"ipdTimelineMainLayout_title__6Ox2X","dividerStyle":"ipdTimelineMainLayout_dividerStyle__yz1H+"};